/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Bluefin/view.blocks to change it.
import AccessKey from './AccessKey/index'
import AccountId from './AccountId/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Bluefin({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Bluefin"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Bluefin.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AccountId
  viewPath={`${viewPath}/AccountId`}
/>
<AccessKey
  viewPath={`${viewPath}/AccessKey`}
/>
</div>
{children}
</React.Fragment>)
}